module.exports = __webpack_public_path__ + "static/media/new_logo.1a9568bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new_logo.svg
// module id = 529
// module chunks = 0